import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OperatorStatusPill } from '../../../components/dashboard/OperatorStatusPill';
import type { OperatorDisplayStatus } from '../../../lib/dashboard/operatorDisplayStatus';

type DisplayManageMobileChromeProps = {
  screenName: string;
  status: OperatorDisplayStatus;
};

/** Page chrome for the companion manage route — back + identity + status. */
export function DisplayManageMobileChrome({
  screenName,
  status,
}: DisplayManageMobileChromeProps) {
  const { t } = useTranslation('displays');
  return (
    <header className="flex flex-col gap-3">
      <Link
        to="/screens"
        className="inline-flex w-fit items-center gap-1.5 text-[13px] font-semibold no-underline"
        style={{ color: 'var(--gs-muted)' }}
      >
        <svg className="rtl:-scale-x-100" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden>
          <path d="m15 6-6 6 6 6" />
        </svg>
        {t('manage.mobile.back')}
      </Link>
      <div className="flex items-start justify-between gap-3">
        <h1
          className="m-0 min-w-0 text-[26px] font-extrabold leading-tight tracking-[-0.03em]"
          style={{ color: 'var(--gs-ink)' }}
        >
          {screenName}
        </h1>
        <OperatorStatusPill status={status} />
      </div>
    </header>
  );
}
